import { MenuItem, TextField } from "@mui/material";
import { GridRenderCellParams, useGridApiContext } from "@mui/x-data-grid-premium";

export interface attributeToUpdateProps {
  Id: string | number;
  Value?: string | number;
  ValueId?: string | number;
  UnitId?: string | number;
}

export const AttibuteInputCell = ({
  params,
  referenceData,
  attributesToUpdate,
  setAttributesToUpdate,
}: {
  params: GridRenderCellParams;
  referenceData: any; // the big referenceData object
  attributesToUpdate: attributeToUpdateProps[];
  setAttributesToUpdate: React.Dispatch<React.SetStateAction<attributeToUpdateProps[]>>;
}) => {
  const apiRef = useGridApiContext();

  // 1) Retrieve the array of properties from referenceData
  const productProperties = referenceData?.ProductTypeProperties?.Properties || [];

  // 2) Find the property that matches the current cell’s params.id
  const currentProperty = productProperties.find(
    (prop: any) => prop.Id == params.id
  );

  const isBoolean = params?.row?.AttributeDataType?.Value === "Boolean";
  const isSelect = !!currentProperty?.Enumerated || isBoolean;
  const isNumber =
    params?.row?.AttributeDataType?.Value === "Decimal" ||
    params?.row?.AttributeDataType?.Value === "Integer";

 

  let enumerationValues = currentProperty?.EnumerationValues || [];
  if (isBoolean) {
    // Force boolean to be a True/False select
    enumerationValues = [
      { Id: 1, Name: "True" },
      { Id: 0, Name: "False" },
    ];
  }

  const id = params.id;
  const value = params.value ?? ""; // fallback for blank fields
  const field = params.field;

  const updateAttributesToUpdate = (attribute: attributeToUpdateProps) => {
    const existingAttributeIndex = attributesToUpdate.findIndex(
      (atr) => atr.Id == attribute.Id
    );
    let postableAttribute = { ...attribute };

    if (isSelect && !isBoolean) {
      const matchingEnumObj = enumerationValues.find(
        (ev: any) => ev.Name == attribute.Value
      );
      postableAttribute.ValueId = matchingEnumObj?.Id ?? null;
    }

    if (existingAttributeIndex === -1) {
      setAttributesToUpdate((prev) => [...prev, postableAttribute]);
    } else {
      const newAttributes = [...attributesToUpdate];
      newAttributes[existingAttributeIndex] = postableAttribute;
      setAttributesToUpdate(newAttributes);
    }
  };

  const handleChange = async (event: any) => {
    const raw = event.target.value;

    let nextValue: string | number = raw;

    if (isBoolean) {
      // Normalize any truthy/falsey raw values into "True"/"False" strings
      if (raw === true || raw === "true" || raw === 1 || raw === "1") {
        nextValue = "True";
      } else if (raw === false || raw === "false" || raw === 0 || raw === "0") {
        nextValue = "False";
      } else {
        nextValue = String(raw);
      }
    }

    await apiRef.current.setEditCellValue({
      id,
      field,
      value: nextValue,
    });

    updateAttributesToUpdate({ Id: id, Value: nextValue });

    // For selects, end edit mode on selection
    if (isSelect) {
      apiRef.current.stopCellEditMode({ id, field });
    }
  };

  return (
    <TextField
      value={value}
      onChange={handleChange}
      select={isSelect}
      type={isNumber ? "number" : "text"}
      sx={{ "& fieldset": { border: "none" } }}
      size="small"
      variant="outlined"
      fullWidth
      autoFocus
    >
      {isSelect &&
        enumerationValues.map((option: any) => (
          <MenuItem key={option.Id} value={option.Name}>
            {option.Name}
          </MenuItem>
        ))}
    </TextField>
  );
};
